import { motion } from "framer-motion";
import { useLang } from "../contexts/LanguageContext";

const WORDS_EN = ["Clarity", "•", "Cash Flow", "•", "Controls", "•", "Compliance", "•", "Confidence", "•", "Capital Bay", "•"];
const WORDS_AR = ["وضوح", "•", "التدفق النقدي", "•", "الضوابط", "•", "الامتثال", "•", "الثقة", "•", "كابيتال باي", "•"];

export default function Marquee() {
  const { lang } = useLang();
  const words = lang === "ar" ? WORDS_AR : WORDS_EN;
  const line = words.join("   ");

  return (
    <section
      aria-hidden="true"
      className="py-14 md:py-20 bg-cb-primary text-cb-cream overflow-hidden select-none"
      data-testid="marquee"
    >
      <div className="relative">
        <motion.div
          className="flex whitespace-nowrap gap-16 will-change-transform"
          animate={{ x: lang === "ar" ? ["-50%", "0%"] : ["0%", "-50%"] }}
          transition={{ duration: 60, ease: "linear", repeat: Infinity }}
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          {[0, 1, 2].map((k) => (
            <span
              key={k}
              className="text-[9vw] md:text-[7vw] leading-none tracking-tight text-cb-cream/95"
              style={{ fontWeight: 300, fontStyle: "italic" }}
            >
              {line}&nbsp;&nbsp;&nbsp;
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
